module.exports = __webpack_public_path__ + "static/media/web.c12db8f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/web.gif
// module id = 67
// module chunks = 0